import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/style.css";
import { auth, db } from "./firebase";
import { Element, scroller } from "react-scroll";
import firebase from "firebase/compat/app";

const Chapter5_3 = () => {
  const navigate = useNavigate();
  const [selectedAnswers, setSelectedAnswers] = useState({ q1: "", q2: "" });
  const [error, setError] = useState("");
  const [userId, setUserId] = useState(null);

  const questions = [
    {
      question: "Frage 1: Was beschreibt das Internet of Things (IoT)?",
      options: [
        {
          value: "A",
          label:
            "Eine Vernetzung von Geräten, die über das Internet miteinander kommunizieren können.",
        },
        {
          value: "B",
          label:
            "Eine Sammlung von Webseiten, die nur von Geräten wie Smartphones und Tablets erreichbar sind.",
        },
      ],
      correct: "A",
    },
    {
      question: "Frage 2: Was ist ein großer Vorteil des IoT?",
      options: [
        {
          value: "A",
          label: "Der Gewinn von sehr vielen Echtzeitdaten von Dingen des tätlichen Lebens.",
        },
        {
          value: "B",
          label: "Über jedes Gerät jederzeit erreichbar zu sein. ",
        },
      ],
      correct: "A",
    },
  ];
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      scroller.scrollTo(location.hash.substring(1), {
        duration: 500,
        smooth: true,
        offset: -50,
      });
    }
  }, [location]);
 
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid); 
      } else {
        console.error("Kein authentifizierter Benutzer gefunden");
        setError("Benutzer ist nicht authentifiziert");
        navigate("/cybersecurity/login"); 
      }
    });

    
    return () => unsubscribe();
  }, [navigate]);

  
  useEffect(() => {
    console.log("Aktuelle userId in 5_3.js:", userId);
  }, [userId]);

  const handleLogout = () => {
    
    auth
      .signOut()
      .then(() => {
        
        window.location.href = "/login"; 
      })
      .catch((error) => {
        console.error("Logout fehlgeschlagen:", error);
      });
  };

  const handleAnswerChange = (questionIndex, value) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionIndex]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const correctAnswers = questions.every(
      (q, index) => selectedAnswers[index] === q.correct
    );

    if (correctAnswers) {
      try {
        if (!userId) {
          console.error("userId ist nicht definiert");
          setError("Ein Fehler ist aufgetreten.");
          return;
        }

        
        const userDoc = await db.collection("cybersecurityProgress").doc(userId).get();

        console.log("userDoc:", userDoc.exists); 

        if (userDoc.exists) {
          
          await db
            .collection("cybersecurityProgress")
            .doc(userId)
            .update({
              lastChapter: "5_3",
              completedChapters:
                firebase.firestore.FieldValue.arrayUnion("5_3"),
            });
          console.log("Dokument aktualisiert mit Kapitel 5_3.");
        } else {
          
          await db
            .collection("cybersecurityProgress")
            .doc(userId)
            .set({
              lastChapter: "5_3",
              completedChapters: ["5_3"],
            });
          console.log("Dokument erstellt mit Kapitel 5_3");
        }

        navigate("/cybersecurity/5_4"); 
      } catch (error) {
        console.error("Fehler beim Aktualisieren des Fortschritts:", error);
        setError("Ein Fehler ist aufgetreten. Versuche es später erneut.");
      }
    } else {
      setError("Die Antworten sind nicht korrekt. Versuche es erneut.");
    }
  };
  return (
    <div className="container">
      <div className="container py-5">
        <img
          src="/images/zebbs_Logo.svg"
          class="d-block mx-auto mb-4"
          alt=""
          style={{ width: "20%" }}
        />
        <div className="d-flex justify-content-between align-items-center mb-5 p-3 bg-body-tertiary rounded-3">
          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-chevron mb-0">
              {/* Startseite (Home) */}
              <li className="breadcrumb-item">
                <Link className="link-body-emphasis" to="/cybersecurity/course-overview">
                  <i className="bi bi-house-door-fill"></i>
                  <span className="visually-hidden">Home</span>
                </Link>
              </li>

              {/* Library Link */}
              <li className="breadcrumb-item">
                <Link
                  className="link-body-emphasis fw-semibold text-decoration-none"
                  to="/cybersecurity/course-overview"
                >
                  5. Endpunktsicherheit
                </Link>
              </li>

              {/* Aktuelle Seite */}
              <li className="breadcrumb-item active" aria-current="page">
                IoT-Geräte
              </li>
            </ol>
          </nav>

          {/* Logout-Button */}
          <button className="btn btn-outline-dark" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <div
          className="p-5 m-0 rounded-3"
          style={{
            position: "relative",
            backgroundColor: "#009fe0",
            margin: "25px",
            textAlign: "center",
          }}
        >
          <h3 className="text-center p-5">Kapitel 5: Endpunktsicherheit</h3>
          <h2 className="text-center p-3">IoT-Geräte</h2>
          <img
            src="/images/iot.webp"
            alt="IoT"
            style={{ position: "relative", maxWidth: "20%", height: "auto" }}
          />
        </div>

        <div className="p-5 text-center">
          <h3 className="p-5">Was ist das IoT?</h3>
          <p className="col-lg-11 mx-auto">
            Das <strong> Internet of Things (IoT) </strong> vernetzt physische
            Geräte wie Überwachungskameras, Rasenmähroboter, Smart-TVs, Sensoren
            für Patienten zur Überwachung nach Operationen, GPS-Tracker auf Vieh
            zur Standortbestimmung, Verkehrsüberwachungssysteme in Städten zur
            Steuerung des Verkehrsflusses und industrielle Maschinen, die über
            das Internet kommunizieren und oft eigenständig agieren. Diese
            spezialisierten Geräte, sogenannte „Things“, sammeln reale Daten
            und tauschen sie über das Internet oder andere Netzwerke aus.
            <br />
            <br />
            IoT-Geräte liefern ständig <strong>Echtzeit-Daten </strong>über
            physische Zustände und ermöglichen es Unternehmen, sowohl zu
            überwachen als auch zu steuern, was gerade geschieht. Diese
            IoT-Daten müssen sofort verarbeitet werden, was hohe Anforderungen
            an Netzwerkbandbreite und Konnektivität stellt. <br />
            <br />
            Das Internet der Dinge (IoT) ist also keine einzelne Technologie,
            sondern ein <strong> IoT-System. </strong> Eine Kombination aus
            Geräten, Netzwerken, Rechenressourcen und Software. Die zentralen
            Bestandteile sind:
          </p>
        </div>

        <div class="row row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-2 g-3 p-5">
          <div class="p-3 text-center">
            <h4>IoT-Geräte (Things)</h4>
            <p>
              Diese Geräte, wie Sensoren oder smarte Geräte, sind
              spezialisierte kleine Computer mit eingebautem Prozessor, Firmware
              und Netzwerkfähigkeit. Sie sammeln spezifische Daten und versenden diese
              meistens über das Internet. Sie sind oft batteriebetrieben oder
              per Akku aufladbar und nutzen drahtlose Netzwerke wie Wi-Fi oder
              Mobilfunknetze.
            </p>
          </div>

          <div class="p-3 text-center">
            <h4>Verbindungen</h4>
            <p>
              Die Daten müssen über Netzwerke übertragen und gesammelt werden.
              Hierzu werden oft IP-Netzwerke genutzt. Die Daten gelangen meist
              an eine Zwischenstation, wie ein IoT-Gateway, das die Daten
              vorverarbeitet, filtert und weiterleitet. Das{" "}
              <strong> IoT-Gateway </strong>
              verbindet die verschiedenen Teile eines IoT-Systems und ermöglicht
              die Kommunikation.
            </p>
          </div>
        </div>
        <div class="row row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-2 g-3 p-5">
          <div class="p-3 text-center">
            <h4>Backend (in Cloud oder Rechenzentrum)</h4>
            <p>
              Im Backend werden große Datenmengen empfangen und in Echtzeit
              verarbeitet, analysiert und gespeichert. Aus den Daten werden auch
              Werte gesammelt, die die Grundlage für maschinelles Lernen
              liefern. Das Backend sendet anschließend Steuerungsbefehle an das
              Frontend.
            </p>
          </div>

          <div class="p-3 text-center">
            <h4>Frontend (Benutzer-App)</h4>
            <p>
              Das Frontend kommuniziert mit dem Backend über APIs. Es zeigt dem
              Benutzer die Daten oder Funktionen in Web-Apps, mobilen Apps oder
              Dashboards.
            </p>
          </div>
        </div>
        <div className="p-5 text-center">
          <p className="col-lg-11 mx-auto">
            Der eigentliche Vorteil des IoT liegt in den{" "}
            <strong> Echtzeit-Daten. </strong> Millionen von IoT-Sensoren in
            Maschinen, Fahrzeugen oder Gebäuden liefern Daten, die durch
            Analysen wertvolle Einblicke bieten. Mithilfe dieser Daten können
            Unternehmen Muster erkennen, präzise Vorhersagen treffen und
            zukünftige Ereignisse besser planen. Beispielsweise können
            Sensordaten aus einer Industriemaschine genutzt werden, um
            Abweichungen zu erkennen und vorherzusagen, wann eine Wartung nötig
            ist. Dadurch können Unternehmen proaktiv handeln, Ersatzteile
            rechtzeitig bestellen und Wartungen ohne großen Betriebsunterbruch
            durchführen. Dieses Verfahren nennt man{" "}
            <strong> "Predictive Maintenance" </strong>. Es ist besonders in
            großen Produktionsanlagen wertvoll. <br />
            <br />
            IoT bietet also unmittelbares Wissen durch die Messung und
            Berichterstattung realer Bedingungen in Echtzeit, sodass die
            Entscheider sofort reagieren können.
          </p>

          <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
            <img
              src="/images/fact.svg"
              alt="Transparent"
              style={{
                position: "relative",
                maxWidth: "8%",
                height: "auto",
              }}
            />
            Versicherungen nutzen IoT-Daten, um neue Preismodelle zu entwickeln.
            In der Kfz-Versicherung bieten Versicherer „Pay-as-you-drive“-Tarife
            an, bei denen Fahrverhalten, Fahrstrecken und Nutzung direkt die
            Versicherungsprämien beeinflussen. Telematikgeräte im Fahrzeug
            sammeln Fahrdaten, und die Versicherer passen die Prämien basierend
            auf Fahrstil, Strecken und Zeiten an. Dies schafft nicht nur neue Preismodelle, sondern auch eine zusätzliche Datenquelle für die Risikobewertung in der
            Versicherungsbranche.
          </p>

        <p className="col-lg-11 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-beispiel rounded-2">
              <img
                src="/images/attack.svg"
                alt="Transparent"
                style={{
                  position: "relative",
                  maxWidth: "8%",
                  height: "auto",
                }}
              />
              Anfang 2026 konnte ein Forscher durch eine Schwachstelle in der Backend-Anbindung der DJI Romo Saugroboter tausende Geräte weltweit erreichen – inklusive Wohnungsplänen, Standortdaten und (je nach Modell/Funktion) Kamera-Zugriff. (Quelle: https://www.bleepingcomputer.com/news/security/dji-romo-robots-vulnerable-to-hacking-through-backend-flaw/)
            </p>








        </div>
      </div>

      <div className="grey-section">
        <div className="container p-5">
          <div className="pt-5 text-center">
            <h3 className="p-5">
              Beispiel für den Ablauf eines Smart-Home-Lichtsystems und die
              Schwachstellen:
            </h3>
            <p className="col-lg-11 mx-auto">
              Das IoT-Gerät ist die smarte Glühbirne, die mit einem Smartphone
              gesteuert werde kann. Sie ist über WLAN mit dem Internet verbunden
              und empfängt Befehle, z. B. „Einschalten“ oder „Helligkeit
              reduzieren“, und führt diese aus.
              <section class="pt-5 text-start">
                <ul class="timeline">
                  <li class="timeline-item mb-5">
                    1. Das Smartphone sendet den "Licht einschalten"-Befehl über
                    das Internet und (falls vorhanden) das Gateway an das
                    Backend.
                    <br />
                    <br />
                    Schwachstelle: Wenn die Daten zwischen dem Smartphone, dem
                    Backend und der Glühbirne nicht verschlüsselt übertragen
                    werden, könnten Angreifer diese Daten abfangen (z. B. durch
                    einen Man-in-the-Middle (MITM)-Angriff). Viele IoT-Geräte verwenden veraltete Firmware oder haben
                    Sicherheitslücken, die nicht gepatcht werden. Ein Angreifer
                    könnte das Gerät direkt übernehmen (z. B. per
                    Firmware-Manipulation).
                  </li>
                  <li class="timeline-item mb-5">
                    2. Das Backend empfängt den Befehl und prüft:
                    <ul>
                      <li>
                        Ist das Smartphone authentifiziert und autorisiert, um
                        diese Glühbirne zu steuern?
                      </li>
                      <li>
                        Ist die Glühbirne online und bereit, Befehle zu
                        empfangen?
                      </li>
                    </ul>
                    <br />
                    Schwachstelle: Wenn das System schwache Passwörter verwendet
                    oder keine Multi-Faktor-Authentifizierung (MFA) unterstützt,
                    können Angreifer Zugriff auf das Backend oder das
                    Benutzerkonto erhalten.
                  </li>
                  <li class="timeline-item mb-5">
                    3. Nachdem die Authentifizierung erfolgreich ist,
                    verarbeitet das Backend den Befehl und wandelt ihn ggf. in
                    ein Protokoll um, das die Glühbirne versteht (z. B. Zigbee).
                    <br />
                    <br />
                    Schwachstelle: Das Backend ist ein zentraler Angriffspunkt.
                    Ein erfolgreicher Angriff auf die Server (z. B. durch
                    SQL-Injection, Phishing oder DoS-Attacken) könnte
                    Angreifern ermöglichen, Kontrolle über alle angebundenen
                    Glühbirnen zu erlangen.
                  </li>
                  <li class="timeline-item mb-5">
                    4. Das Backend sendet den verarbeiteten Befehl über das
                    Internet an die Glühbirne (direkt oder über ein Gateway,
                    falls verwendet).
                    <br />
                    <br />
                    Schwachstelle: Wenn ein Smart-Home-Gateway im Netzwerk
                    verwendet wird und nicht ordnungsgemäß gesichert ist, kann
                    es ein Einstiegspunkt für Angriffe werden.
                  </li>
                  <li class="timeline-item mb-5">
                    5. Die Glühbirne empfängt den Befehl und führt die Aktion
                    aus, z. B. das Einschalten des Lichts oder das Anpassen der
                    Helligkeit.
                  </li>
                  <li class="timeline-item mb-5">
                    6. Die Glühbirne sendet eine Rückmeldung an das Backend, z.
                    B.:
                    <ul>
                      <li>"Licht eingeschaltet"</li>
                      <li>Aktuelle Helligkeit oder Farbeinstellung</li>
                    </ul>
                  </li>
                  <li class="timeline-item mb-5">
                    7. Das Backend speichert den Status der Glühbirne (z. B.
                    „An“, „Helligkeit: 70%“) in einer Datenbank.
                  </li>
                  <li class="timeline-item mb-5">
                    8. Das Backend aktualisiert den Status der Glühbirne und
                    sendet ihn an die App auf dem Smartphone, sodass man sehen
                    kann, dass das Licht jetzt eingeschaltet ist.
                  </li>
                  <li class="timeline-item mb-5">
                    9. Falls ein Zeitplan eingerichtet ist oder
                    Automatisierungen laufen, prüft das Backend parallel ob es
                    Regeln gibt, die ausgeführt werden müssen (z. B. schalte
                    nach 2 Stunden automatisch aus)?
                  </li>
                </ul>
              </section>
            </p>

            <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
              <img
                src="/images/fact.svg"
                alt="Transparent"
                style={{
                  position: "relative",
                  maxWidth: "8%",
                  height: "auto",
                }}
              />
              In vielen Städten weltweit werden IoT-Technologien genutzt, um
              Städte effizienter und lebenswerter zu machen. Zum Beispiel gibt
              es in Barcelona IoT-Sensoren, die freie Parkplätze anzeigen, und
              Straßenlaternen, die sich automatisch an die Lichtverhältnisse
              anpassen. Diese Smart Cities sparen so Energie und verbessern die
              Lebensqualität. Jede dieser IoT-Schnittstellen stellt einen weiteren Angriffspunkt für mögliche Angreifer dar. 
            </p>
          </div>
        </div>
      </div>

      <div className="gelb-section">
        <div className="container p-5">
          <div className="p-5 text-center">
            <h3 className="p-5">Herausforderungen bei IoT-Projekten</h3>
            <p className="col-lg-11 mx-auto">
              IoT-Projekte sind konkrete Anwendungen oder Vorhaben, bei denen
              IoT-Technologien genutzt werden, um physische Geräte, Sensoren
              oder Systeme zu vernetzen, Daten zu erfassen, zu analysieren und
              darauf basierend Aktionen auszuführen. IoT-Projekte bieten viele
              Vorteile für Unternehmen, aber sie bringen auch Herausforderungen
              mit sich, die berücksichtigt werden müssen:
              <br />
              <br />
            </p>

            <p className="col-lg-10 text-start mx-auto">
              <strong>Projektplanung: </strong>Es gibt derzeit keine
              verbindlichen internationalen Standards für die Gestaltung und
              Umsetzung für die Entwicklung von IoT-Architekturen, was
              Flexibilität, aber auch Designfehler ermöglicht. Diese Projekte
              sollten von IT-Experten mit IoT-Erfahrung geleitet werden, wobei
              gründliche Tests und Machbarkeitsstudien unverzichtbar sind.{" "}
              <br />
              <br />
              <strong>Datenmanagement: </strong>IoT-Geräte erzeugen riesige
              Datenmengen, die gespeichert und gesichert werden müssen.
              IoT-Daten sind oft zeitkritisch und haben kürzere Lebenszyklen als
              herkömmliche Geschäftsdaten, was spezifische Speicher- und
              Managementlösungen erfordert. <br />
              <br />
              <strong>Netzwerkunterstützung: </strong>IoT-Daten benötigen
              zuverlässige Netzwerke mit ausreichender Bandbreite, um
              Verzögerungen zu vermeiden. Unternehmen könnten Daten lokal
              vorverarbeiten und nur wichtige Informationen an eine zentrale
              Stelle senden. <br />
              <br />
              <strong>Sicherheit: </strong>Da IoT-Geräte kleine, vernetzte
              Computer sind, sind sie anfällig für Angriffe und Datenmissbrauch.
              Sicherheitsrisiken können auch Compliance-Probleme verursachen,
              wenn z. B. Patientendaten gestohlen werden oder die Produktion
              durch Phishing lahmgelegt wird. Eine sichere Konfigurationen zum
              Schutz der Geräte und der Daten während der Übertragung und
              Speicherung ist demnach unerlässlich, auch im Hinblick auf
              regulatorische Vorgaben. <br />
              <br />
              <strong>Gerätemanagement: </strong>Die Verwaltung vieler
              IoT-Geräte ist komplex. Jedes Gerät muss beschafft, installiert,
              verbunden, gewartet und irgendwann ersetzt werden. Dies erfordert
              umfassende Werkzeuge zur Verwaltung und Wartung, um die
              zahlreichen Geräte effizient und sicher zu betreiben. <br />
              <br />
            </p>

            <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
              <img
                src="/images/fact.svg"
                alt="Transparent"
                style={{
                  position: "relative",
                  maxWidth: "8%",
                  height: "auto",
                }}
              />
              Im Jahr 2015 demonstrierten zwei Sicherheitsforscher eindrucksvoll
              die potenziellen Risiken vernetzter Fahrzeuge, indem sie aus der
              Ferne die Kontrolle über einen Jeep Cherokee übernahmen. Durch
              eine Schwachstelle im Infotainmentsystem Uconnect gelang es ihnen,
              über das Mobilfunknetz auf kritische Fahrfunktionen zuzugreifen.
              Sie konnten unter anderem die Bremsen deaktivieren, den Motor
              abstellen und sogar die Lenkung beeinflussen. Diese Demonstration
              führte dazu, dass Fiat-Chrysler rund 1,4 Millionen Fahrzeuge für
              ein Software-Update zurück rufen musste, um die Sicherheitslücke zu
              schließen.
            </p>
          </div>
        </div>
      </div>

      <div className="white-section">
        <div className="container p-5">
          <div className="p-5 text-center">
            <h3 className="p-5">Best Practices für IoT-Sicherheit </h3>
            <p className="col-lg-11 mx-auto">
              Besonders herausfordernd ist die schiere Anzahl von IoT-Geräten:
              Eine Implementierung kann zehntausende Geräte umfassen, die alle
              potenzielle Angriffsziele darstellen. Um diese Risiken zu
              minimieren, müssen IT-Administratoren Tools nutzen, um alle
              IoT-Geräte zu identifizieren, optimal zu konfigurieren und
              kontinuierlich zu überwachen.
              <br />
              <br />
              Die Sicherheit von IoT-Geräten dreht sich um drei wesentliche
              Bereiche:
            </p>
            <p className="col-lg-11 text-start mx-auto">
              <ul>
                <li>
                  <strong>Design: </strong> Auswahl von Geräten mit starken
                  Sicherheitsmerkmalen, wie Verschlüsselung und
                  Update-Funktionen.
                </li>

                <br />
                <li>
                  <strong>Prozesse: </strong> Einführung von Tools und
                  Richtlinien, die sichere Konfigurationen und regelmäßige
                  Firmware-Updates sicherstellen.
                </li>

                <br />
                <li>
                  <strong>Sorgfalt: </strong> Einsatz von Überwachungs- und
                  Sicherheits-Tools, um Angriffe, Malware oder Anomalien
                  frühzeitig zu erkennen.
                </li>
              </ul>
            </p>
            <p className="col-lg-11 mx-auto">
              <br />
              <br />
              Eine wirksame Sicherheitsstrategie für IoT-Geräte umfasst Ansätze
              wie Netzwerksegmentierung, separate IoT-Netzwerke und regelmäßige
              Firmware-Updates. <br />
              <br />
              <Link to="/cybersecurity/4_2#netzsegment" className="icon-link">
                <svg className="bi" aria-hidden="true">
                  <use xlinkHref="#book"></use>
                </svg>{" "}
                Netzwerksegmentierung:
              </Link>
              IoT-Geräte werden in ein separates Netzwerksegment ausgelagert, um
              sie vom Hauptnetzwerk zu isolieren. Dadurch wird verhindert, dass
              kompromittierte IoT-Geräte direkten Zugriff auf sensible
              Unternehmensressourcen haben. Dieses Konzept reduziert die
              Angriffsfläche und erlaubt gezielte Sicherheitsrichtlinien für
              jedes Segment, wodurch der Schutz des gesamten Netzwerks erhöht
              wird.
              <br />
              <br />
              <strong>Separate IoT-Netzwerke: </strong>In Heimnetzwerken oder
              kleineren Büroumgebungen bietet ein dediziertes (eigenes) WLAN nur
              für IoT-Geräte zusätzliche Sicherheit. Dieses Netzwerk ist nicht
              mit dem Haupt-WLAN verbunden und kann restriktivere
              Sicherheitsvorgaben wie die Begrenzung des Internetzugangs oder
              Gastnetzwerk-Funktionen nutzen. Dadurch wird das Risiko minimiert,
              dass Schwachstellen in IoT-Geräten auf das Hauptnetzwerk
              übergreifen.
              <br />
              <br />
            </p>
          </div>
        </div>
      </div>

      <div className="white-section">
        <div className="container p5-5">
          <div
            className="safe rounded-2 text-center"
            style={{ backgroundColor: "#fec748" }}
          >
            <img
              src="/images/abwehr.svg"
              alt="Abwehr"
              style={{
                position: "relative",
                maxWidth: "7%",
                height: "auto",
              }}
            />
            <h3 className="p-5">Network Access Control (NAC)</h3>
            <Element name="nac">
              <p className="col-lg-11 mx-auto">
                Wenn immer mehr Mitarbeiter mit mobilen Geräten, IoT-Geräten und
                mobilen Endgeräten auf Unternehmensnetzwerke zugreifen, wird die
                Kontrolle über den Netzwerkzugriff zu einer zentralen
                Herausforderung. Mit einer{" "}
                <strong> Network Access Control (NAC) </strong> kann der Zugriff
                auf Netzwerke reguliert, überwacht und gesteuert werden, um
                sicherzustellen, dass nur{" "}
                <strong>autorisierten Geräten und Benutzern </strong> Zugang
                gewährt wird. <br />
                <br />
                Eine NAC-Lösung überprüft jedes Gerät, das sich mit dem Netzwerk
                verbinden möchte, auf{" "}
                <strong>Authentizität und Sicherheitskonformität. </strong> Dazu
                gehören Faktoren wie aktuelle Sicherheitsupdates, aktivierte
                Antivirensoftware oder korrekt konfigurierte Firewalls. Geräte,
                die diese Standards nicht erfüllen, können automatisch isoliert,
                in eine Quarantänezone verschoben oder vollständig vom Netzwerk
                ausgeschlossen werden. So verhindert NAC, dass unsichere oder
                kompromittierte Geräte Schaden anrichten können.
                <br />
                <br />
                Ein weiterer Vorteil von NAC ist die{" "}
                <strong>Netzwerksegmentierung. </strong> Unterschiedliche
                Benutzerrollen – beispielsweise Administratoren, Mitarbeiter
                oder Gäste – können unterschiedliche Zugriffsrechte erhalten.
                Während ein Administrator vollen Zugriff auf das interne
                Netzwerk hat, kann ein Gast nur auf isolierte Ressourcen
                zugreifen, ohne das Kerngeschäft zu gefährden.
                <br />
                <br />
                Moderne NAC-Systeme arbeiten häufig dynamisch und können
                Sicherheitsrichtlinien in Echtzeit anpassen. Durch die
                Integration mit{" "}
                <Link to="/cybersecurity/4_3#siem" className="icon-link">
                  <svg className="bi" aria-hidden="true">
                    <use xlinkHref="#book"></use>
                  </svg>{" "}
                  Security Information and Event Management (SIEM)
                </Link>{" "}
                können sicherheitsrelevante Ereignisse zentral erfasst und
                analysiert werden.
                <br />
                <br />
                NAC-Lösungen helfen also dabei IoT-Geräte zu identifizieren, zu
                überwachen und in sichere Netzwerksegmente zu isolieren.
              </p>
            </Element>
          </div>
        </div>

        {/* Fragenteil */}
        <div className="container pt-5 my-5">
          <div className="text-center m-4">
            <h2>Überprüfe dein Wissen</h2>
            <p className="col-lg-11 mx-auto">
              Mit den richtigen Antworten kommst du weiter!
            </p>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-8 text-start">
              <form onSubmit={handleSubmit}>
                {questions.map((question, index) => (
                  <div key={index} className="mb-4">
                    <p className="fs-4">{question.question}</p>{" "}
                    {question.options.map((option) => (
                      <div key={option.value} className="form-check">
                        <input
                          className="form-check-input me-2"
                          type="radio"
                          name={`question${index}`}
                          value={option.value}
                          checked={selectedAnswers[index] === option.value}
                          onChange={() =>
                            handleAnswerChange(index, option.value)
                          }
                        />
                        <label className="form-check-label fs-5">
                          {option.label}
                        </label>{" "}
                      </div>
                    ))}
                  </div>
                ))}
                {error && <p className="text-danger">{error}</p>}
                <div className="text-center">
                  <button type="submit" className="btn btn-primary">
                    überprüfen
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* Ende Fragenteil */}
      </div>
    </div>
  );
};

export default Chapter5_3;
